import {IVodItemFragmentFragment} from '@src/Api/Graphql/gql/types.generated';
import {
  PlaybackParams,
  WatchPageRouteParams,
  WatchSource,
} from '@src/Navigation/types/watchPageRouteParams.type';
import {Routes} from '@src/Constant/routes';
import useAppNavigation from '@src/utils/useAppNavigation';
import {useFindProgression} from '@src/Hooks/useFindProgression';
import {useTranslation} from 'gatsby-plugin-react-i18next';
import useTrackCta from '@src/Tracking/useTrackCta';
import {useCallback} from 'react';

export function useVodNavigation() {
  const navigation = useAppNavigation();
  const {findCurrentTime} = useFindProgression();
  const {t} = useTranslation('translation');
  const trackCta = useTrackCta();

  const trackEvent = useCallback(
    async (item: IVodItemFragmentFragment) => {
      await trackCta({
        type: 'banner',
        name: t('Watch') || '',
        section: 'watch',
        page: 'VOD single',
        blockType: 'highlight',
        blockName: item.title || '',
      });
    },
    [trackCta, t],
  );

  const createNavigationParams = useCallback(
    (item: IVodItemFragmentFragment): WatchPageRouteParams => {
      const playbackParams: PlaybackParams = {
        source: WatchSource.VIMEO,
        sourceUrl: '' + (item.sourceUrl ?? ''),
        title: '' + (item.name ?? ''),
        url: '' + (item.url ?? ''),
        videoId: '' + (item.liveEventId ?? ''),
        vimeoId: '' + (item.liveEventId ?? ''),
        byteplusId: '' + (item.byteplusVideoID ?? ''),
        youtubeId: '' + (item.youtubeId ?? ''),
        liveEventId: '' + (item.liveEventId ?? ''),
        videoUrl: item.vimeoHlsUrl,
        id: '' + (item.id ?? ''),
        isFullscreen: true,
      };
      const paywallData = {
        accessType: item.accessType,
        paywall: item.paywall,
      };
      const params: WatchPageRouteParams = {
        time: findCurrentTime(item.id),
        type: 'player',
        paywallData,
        previousScreen: 'content',
        ...playbackParams,
      };
      return params;
    },
    [findCurrentTime],
  );

  const onWatchClick = (item: IVodItemFragmentFragment) => async () => {
    if (!item) return;

    await trackEvent(item);

    const params = createNavigationParams(item);
    await navigation.navigate(Routes.WATCH, {
      state: {params},
    });
  };

  return {navigation, onWatchClick};
}
